import React from "react";
import { processSteps } from "../mock";

const Process = () => {
  return (
    <section id="processus" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-4">
          Processus
        </p>
        <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-neutral-900 leading-tight max-w-4xl">
          De la prise de contact au premier passage :{" "}
          <span className="text-brand">4 étapes, pas une de plus.</span>
        </h2>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {processSteps.map((step, i) => (
            <div key={step.number} className="relative">
              <div className="font-heading font-extrabold text-5xl text-neutral-200">
                {step.number}
              </div>
              <div className="h-px w-full bg-neutral-200 my-5 relative">
                <span className="absolute left-0 top-0 h-px bg-brand w-10" />
              </div>
              <h3 className="font-heading font-bold text-xl text-neutral-900">
                {step.title}
              </h3>
              <p className="mt-3 text-neutral-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
